// As mesas do caixa: quais estão ocupadas e quais estão livres.
import React from "react";
import * as Styles from "../../styles/PointOfSale.styles";

export const TabelaDePedidosDeMesa: React.FC<{
  component: any;
  componentProps: any;
  subsidiaryDataZustand: any;
  ordersTypeTable: string;
  setOrdersTypeTable: (tipo: string) => void;
  handleSearchByOrderTable: (orderUuid: any, order?: any, customer?: any) => void;
  getPeriodInfo: () => void;
}> = ({
  component,
  componentProps,
  subsidiaryDataZustand,
  ordersTypeTable,
  setOrdersTypeTable,
  handleSearchByOrderTable,
  getPeriodInfo,
}) => {
  let currentOrders: any[] =
    subsidiaryDataZustand.selectedPdv.selectedPeriod.periodInfo?.periodOrders?.filter(
      (order: any) => order.orderType === 1
    ) ?? [];
  // Ordena as ordens com base no número da mesa
  currentOrders.sort((a: any, b: any) => {
    const deskNameA =
      subsidiaryDataZustand.selectedPdv.selectedPeriod.periodInfo?.periodDesks?.filter(
        (desk: any) =>
          desk.itemUuid ===
          a.orderInfo?.filter(
            (orderInfoValue: any) =>
              orderInfoValue.orderInfoType === 1
          )[0]?.orderInfoValue
      )[0]?.itemName;

    const deskNameB =
      subsidiaryDataZustand.selectedPdv.selectedPeriod.periodInfo?.periodDesks?.filter(
        (desk: any) =>
          desk.itemUuid ===
          b.orderInfo?.filter(
            (orderInfoValue: any) =>
              orderInfoValue.orderInfoType === 1
          )[0]?.orderInfoValue
      )[0]?.itemName;

    // Extrai o número da mesa da string
    const tableNumberA = parseInt(deskNameA.replace(/[^0-9]/g, ''));
    const tableNumberB = parseInt(deskNameB.replace(/[^0-9]/g, ''));

    // Compara os números das mesas
    return tableNumberA - tableNumberB;
  });
  return (
    <Styles.CurrentOrdersTable
      selected={Boolean(component.componentSelected)}
      componentPosition={componentProps.componentPosition}
      componentBrightness={String(componentProps.componentBrightness)}
      componentStatus={String(componentProps.componentStatus)}
      componentColor={String(componentProps.componentColor)}
      componentFontSize={String(componentProps.componentFontSize)}
      componentWidth={String(componentProps.componentWidth)}
      componentHeight={String(componentProps.componentHeight)}
      componentBackgroundColor={String(
        componentProps.componentBackgroundColor
      )}
    >
      {component.componentSelected && (
        <Styles.SelectedIcon
          top={component.componentProps.componentPosition.y}
          left={component.componentProps.componentPosition.x}
        >
          zoom_out_map
        </Styles.SelectedIcon>
      )}
      <span className="componentTitle">
        ATENDIMENTOS EM ANDAMENTO
      </span>

      <Styles.OrdersTypeButtons>
        <Styles.ShowOrdersTypeButton
          componentBackgroundColor="#1c50fe"
          onClick={() => {
            getPeriodInfo();
            setOrdersTypeTable("OpenDeskOrders");
          }}
        >
          {`Contas Abertas(${currentOrders?.filter(
            (order: any) => order.orderStatus < 6
          ).length
            })`}
        </Styles.ShowOrdersTypeButton>
      </Styles.OrdersTypeButtons>
      {ordersTypeTable === ordersTypeTable && (
        <Styles.OpenOrdersTable
          componentBrightness={"0.9"}
          componentStatus={String(componentProps.componentStatus)}
          componentBackgroundColor="transparent"
          componentColor={String(componentProps.componentColor)}
          componentHeight={String(componentProps.componentHeight)}
        >
          <Styles.OpenOrdersTableHeader
            componentColor={String(componentProps.componentColor)}
          >
            <Styles.OpenOrdersTableHeaderRow>
              <Styles.OpenOrdersTableHeaderCell columnWidth={"35%"}>
                Conta
              </Styles.OpenOrdersTableHeaderCell>
              <Styles.OpenOrdersTableHeaderCell columnWidth={"35%"}>
                Número de Pessoas
              </Styles.OpenOrdersTableHeaderCell>
              <Styles.OpenOrdersTableHeaderCell columnWidth={"30%"}>
                Status
              </Styles.OpenOrdersTableHeaderCell>
            </Styles.OpenOrdersTableHeaderRow>
          </Styles.OpenOrdersTableHeader>
          {currentOrders.map((order: any) => {
            const orderInfoValue = order.orderInfo?.map(
              (info: any) => {
                let parsedOrderInfoValue;
                if (typeof info.orderInfoValue === "string") {
                  try {
                    parsedOrderInfoValue = JSON.parse(
                      info.orderInfoValue
                    );
                  } catch (error) {
                    parsedOrderInfoValue = null;
                  }
                } else {
                  parsedOrderInfoValue = info.orderInfoValue;
                }
                return {
                  ...info,
                  orderInfoValue:
                    parsedOrderInfoValue || info.orderInfoValue,
                };
              }
            );
            const deskName =
              subsidiaryDataZustand.selectedPdv.selectedPeriod.periodInfo?.periodDesks?.filter(
                (desk: any) =>
                  desk.itemUuid ===
                  orderInfoValue?.filter(
                    (orderInfoValue: any) =>
                      orderInfoValue.orderInfoType === 1
                  )[0]?.orderInfoValue
              )[0]?.itemName;
            const numberOfPeople = orderInfoValue?.filter(
              (orderInfoValue: any) =>
                orderInfoValue.orderInfoType === 2
            )[0]?.orderInfoValue;

            return order.orderStatus < 6 && order.orderType === 1 ? (
              <Styles.OpenOrdersTableRow
                key={order.orderUuid}
                onClick={() => {
                  handleSearchByOrderTable(order.orderUuid, order);
                  getPeriodInfo();
                }}
              >
                <Styles.OpenOrdersTableCell columnWidth={"35%"}>
                  {deskName}
                </Styles.OpenOrdersTableCell>
                <Styles.OpenOrdersTableCell columnWidth={"35%"}>
                  {numberOfPeople}
                </Styles.OpenOrdersTableCell>
                <Styles.OpenOrdersTableCell columnWidth={"30%"}>
                  {order.orderStatus === 0
                    ? "Recebido"
                    : order.orderStatus === 1
                      ? "Aberto"
                      : order.orderStatus === 2
                        ? "Em Produção"
                        : order.orderStatus === 3
                          ? "Bloqueada"
                          : order.orderStatus === 5
                            ? "Pagamento"
                            : ""}
                </Styles.OpenOrdersTableCell>
              </Styles.OpenOrdersTableRow>
            ) : null;
          })}
        </Styles.OpenOrdersTable>
      )}
    </Styles.CurrentOrdersTable>
  );
};
